jQuery(document).ready(function ($) {
  const apInfiniteSlickSlider = jQuery(".infinite-slick-slider");
  if (apInfiniteSlickSlider.length) {
    apInfiniteSlickSlider.slick("unslick").data("slick", "");
    apInfiniteSlickSlider.slick({
      slidesToShow: apInfiniteSlickSlider.data("slidestoshow")
        ? apInfiniteSlickSlider.data("slidestoshow")
        : 5,
      autoplay: true,
      autoplaySpeed: 10,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: false,
      cssEase: "linear",
      speed: 10000,
      arrows: false,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: apInfiniteSlickSlider.data("slidestoshow")
              ? apInfiniteSlickSlider.data("slidestoshow")
              : 4,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  const apInfiniteSlickSliderRTL = jQuery(".infinite-slick-slider-rtl");
  if (apInfiniteSlickSliderRTL.length) {
    apInfiniteSlickSliderRTL.slick("unslick").data("slick", "");
    apInfiniteSlickSliderRTL.slick({
      slidesToShow: apInfiniteSlickSliderRTL.data("slidestoshow")
        ? apInfiniteSlickSliderRTL.data("slidestoshow")
        : 5,
      autoplay: true,
      autoplaySpeed: 10,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: false,
      cssEase: "linear",
      speed: 10000,
      arrows: false,
      rtl: true,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: apInfiniteSlickSliderRTL.data("slidestoshow")
              ? apInfiniteSlickSliderRTL.data("slidestoshow")
              : 4,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  const aprioritMasonrySlider = jQuery(".masonry-slider");
  if (aprioritMasonrySlider.length) {
    if (window.innerWidth < 576) {
      const sliderIMGs = aprioritMasonrySlider.find(".wp-block-image");
      const sliderIMGsFiltered = sliderIMGs.filter(function (index, element) {
        const imgSrc = jQuery(element).find("img").attr("src");
        if (imgSrc === "/wp-content/uploads/2023/09/photo-team-2.jpg") {
          return false;
        }
        return true;
      });

      // Create a new slider and append the images to it
      const mobMasonrySlider = jQuery(
        '<div class="mobile-masonry-slider"></div>'
      );
      mobMasonrySlider.append(sliderIMGsFiltered);

      // Replace the default slider with the mobile slider
      aprioritMasonrySlider.replaceWith(mobMasonrySlider);

      const settingsMobMasonrySlider = {
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        infinite: true,
        arrows: false,
        variableWidth: true,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        focusOnSelect: false,
        mobileFirst: true,
        variableWidth: true,
      };

      // Initialize the Slick Slider
      mobMasonrySlider.slick(settingsMobMasonrySlider);

      // Set constant speed for different width images
      mobMasonrySlider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          const slideElement = slick.$slides.get(currentSlide);
          const slideWidth = slideElement.offsetWidth;
          const baseSpeed = 0.06;
          const calculatedSpeed = Math.floor(slideWidth / baseSpeed);

          slick.options.speed = calculatedSpeed;
        }
      );

      // Pause on click
      let isPaused = false;
      mobMasonrySlider.on("click", ".slick-slide", function (event) {
        event.preventDefault();

        if (!isPaused) {
          // Get the index of the clicked slide
          let clickedSlideIndex = jQuery(this).data("slick-index");

          // Destroy the current slider
          mobMasonrySlider.slick("unslick");
          // Initialize a new slider
          mobMasonrySlider.slick({
            ...settingsMobMasonrySlider,
            initialSlide: clickedSlideIndex,
          });

          // Go to the clicked slide
          mobMasonrySlider.slick("slickPause");
          isPaused = true;
        } else {
          mobMasonrySlider.slick("slickPlay");
          isPaused = false;
        }
      });
    } else {
      aprioritMasonrySlider.slick("unslick").data("slick", "");

      aprioritMasonrySlider.slick({
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        cssEase: "linear",
        infinite: true,
        arrows: false,
        variableWidth: true,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        focusOnSelect: false,
      });

      // On before slide change
      aprioritMasonrySlider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          const slideElement = slick.$slides.get(currentSlide);
          const slideWidth = slideElement.offsetWidth;
          const baseSpeed = 0.06;
          const calculatedSpeed = Math.floor(slideWidth / baseSpeed);

          slick.options.speed = calculatedSpeed;
        }
      );
    }
  }

  $(".infinite-half-way-slider").each(function () {
    const infiniteHalfWaySliderWrapper = $(this).find(".wp-block-gallery");
    infiniteHalfWaySliderWrapper
      .find("figure")
      .clone()
      .appendTo(infiniteHalfWaySliderWrapper);
  });
});
